import React from 'react';
import SeoHead from '../components/SeoHead';
import { AD_POSITIONS } from '../utils/adFormats';

const AUDIENCE = [
  {
    title: 'Intent auditoriya',
    text: 'Foydalanuvchi avtomobil tarixini / DTP ni tekshiradi — xarid qarori oldidan. Bu oddiy banner trafikidan kuchliroq kontekst.'
  },
  {
    title: 'Kim uchun mos',
    text: 'Avtoservis, ehtiyot qismlar, sug‘urta, lizing, dilerlar, avtoyuvish, diagnostika, bank mahsulotlari.'
  },
  {
    title: 'Nima beramiz',
    text: 'IAB-ga yaqin o‘lchamlar, view/click hisobot, Telegram kanaliga chiqish imkoniyati (alohida kelishuv).'
  }
];

const AdvertisePage = () => {
  return (
    <div className="media-kit">
      <SeoHead
        title="Reklama — Avto Tarix"
        description="Avto-Tarix.uz reklam formatalari: billboard 970×250, sidebar 300×250/300×600, native feed, mobil va avto kartochka slotlari."
        canonical="https://avto-tarix.uz/reklama"
      />

      <div className="media-kit__hero">
        <h1>Reklama Avto-Tarix.uz da</h1>
        <p>
          Avtomobil tarixini tekshirayotgan auditoriya uchun standart display formatlar.
          Agentliklar odatda tayyorlaydigan o‘lchamlar — maxsus dizayn shart emas.
        </p>
      </div>

      {AUDIENCE.map((block) => (
        <div key={block.title} className="media-kit__card">
          <h3>{block.title}</h3>
          <p>{block.text}</p>
        </div>
      ))}

      <h2 className="section__title" style={{ marginTop: 36 }}>Formatlar</h2>
      <table className="media-kit__table">
        <thead>
          <tr>
            <th>Joy</th>
            <th>O‘lcham</th>
            <th>Fayl</th>
            <th>Izoh</th>
          </tr>
        </thead>
        <tbody>
          {AD_POSITIONS.map((slot) => (
            <tr key={slot.value}>
              <td>
                <strong>{slot.labelRu}</strong>
                <div style={{ color: 'var(--mute)', fontSize: 12, marginTop: 4 }}>{slot.label}</div>
              </td>
              <td>{slot.size}</td>
              <td>{slot.accept}</td>
              <td>{slot.hint}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="media-kit__card">
        <h3>Texnik talablar</h3>
        <p>
          JPG / PNG / GIF / MP4. Animatsiya GIF — 30 soniyagacha. Video — ovozsiz loop.
          Kreativda majburiy matn yozilmasin — sayt «Reklama» belgisini o‘zi qo‘yadi.
          Havola HTTPS bo‘lishi shart.
        </p>
      </div>

      <div className="media-kit__cta">
        <a className="btn btn-primary" href="https://t.me/avto_tarix_uz" target="_blank" rel="noopener noreferrer">
          Telegram orqali bog‘lanish
        </a>
        <a className="btn btn-secondary" href="mailto:info@avto-tarix.uz">
          info@avto-tarix.uz
        </a>
      </div>
    </div>
  );
};

export default AdvertisePage;
